import React, { useContext } from "react";

export const MobileSidebarContext = React.createContext();

export const useMobileSidebar = () => {
  return useContext(MobileSidebarContext);
};
